/**
 * Perfil do cliente e condições clínicas usadas para recomendação de colchão.
 *
 * ATENÇÃO: este é um sistema de apoio a venda/configuração técnica.
 * Não substitui orientação médica. As recomendações são baseadas em
 * práticas da indústria, não em literatura clínica peer-reviewed.
 */
export const SLEEP_POSITION_LABELS = {
    lateral: 'De lado',
    supino: 'De costas',
    prono: 'De bruços',
    misto: 'Varia durante a noite',
};
export const MEDICAL_CONDITIONS = [
    {
        id: 'escoliose',
        label: 'Escoliose',
        descricao: 'Curvatura lateral da coluna. Demanda suporte uniforme e conformidade moderada.',
    },
    {
        id: 'hernia-disco',
        label: 'Hérnia de disco',
        descricao: 'Requer alinhamento firme da coluna para reduzir compressão discal.',
    },
    {
        id: 'bico-papagaio',
        label: 'Bico de papagaio',
        descricao: 'Osteófitos vertebrais. Pede alívio de pressão sem afundar a coluna.',
        aliases: ['osteófitos', 'espondilose'],
    },
    {
        id: 'lombalgia',
        label: 'Lombalgia crônica',
        descricao: 'Dor lombar recorrente. Colchão médio-firme com boa transição.',
        aliases: ['dor lombar'],
    },
    {
        id: 'fibromialgia',
        label: 'Fibromialgia',
        descricao: 'Sensibilidade difusa — prioriza alívio de pressão em todos os pontos.',
    },
    {
        id: 'artrose',
        label: 'Artrose',
        descricao: 'Rigidez e dor articular. Memory foam ou látex no topo ajudam.',
    },
    {
        id: 'ma-circulacao',
        label: 'Má circulação',
        descricao: 'Demanda ventilação e materiais que não retenham calor.',
    },
    {
        id: 'apneia',
        label: 'Apneia do sono',
        descricao: 'Elevação e suporte firme para a região torácica superior.',
    },
    {
        id: 'dor-cervical',
        label: 'Dor cervical',
        descricao: 'Tampo com alívio no ombro é fundamental — combinar com travesseiro adequado.',
    },
    {
        id: 'dor-ombro-quadril',
        label: 'Dor em ombro/quadril',
        descricao: 'Demanda alívio de pressão progressivo nos pontos de contato lateral.',
    },
];
export function classifyWeight(pesoKg) {
    if (!pesoKg)
        return 'medium';
    if (pesoKg < 65)
        return 'light';
    if (pesoKg > 95)
        return 'heavy';
    return 'medium';
}
